import $ from "jquery";
import plugin from "@core/plugins/lib";
import { onAvailable } from "@core/plugins/lib/selectors";

export const PLUGIN_NAME = "InViewport";
export const ELEMENT_SELECTOR = "[data-in-viewport]";

if ("IntersectionObserver" in window) {
	$(() => {
		onAvailable.ready(ELEMENT_SELECTOR, function (element) {
			System.import(
				/* webpackChunkName: "plugin--in-viewport" */ "./in-viewport.js"
			).then((module) => {
				plugin(PLUGIN_NAME, module.default);
				$(element)[PLUGIN_NAME]();
			});
		});
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__inviewport/index.js